import { useParams } from "react-router-dom";

function CategoryNews() {
  const { category } = useParams();

  return (
    <div style={{ padding: "16px" }}>
      <h1>{category.toUpperCase()} News</h1>
      {/* later render list based on category */}
    </div>
  );
}

export default CategoryNews;
